import firebase from "firebase/app";
// import "firebase/auth";
import "firebase/database";
// import "firebase/firestore";
import "firebase/messaging";
// import "firebase/functions";
import { FIREBASE_NOTIFICATION, FIREBASE_DATABASE } from "./Urls";
let firebaseNotification;
let firebaseNotificationInstance;
if (!firebase.apps.length) {
  firebase.initializeApp(FIREBASE_DATABASE);
  firebaseNotificationInstance = firebase.initializeApp(
    FIREBASE_NOTIFICATION,
    "notification"
  );
}

if (firebase.messaging.isSupported()) {
  firebaseNotification = firebaseNotificationInstance.messaging();
}

export default firebase;
export { firebaseNotification };

// export const messaging = firebase.messaging();
// export const dbRef = firebase.database();



// WEBPACK FOOTER //
// ./src/utils/firebaseConfig.js